export default "__VITE_ASSET__BRQr9SzD__"